import { Content } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { PageHeader } from '../../components/PageHeader/PageHeader'
import { LanguageSelect } from './LanguageSelect'

export const SettingsRoot = () => {
  const { t } = useTranslation()
  return (
    <Content>
      <PageHeader title={t('Settings')} />
      <LanguageSelect />
    </Content>
  )
}
